import { render, staticRenderFns } from "./MemolanguageView.vue?vue&type=template&id=702a04a5&scoped=true&"
import script from "./MemolanguageView.vue?vue&type=script&lang=js&"
export * from "./MemolanguageView.vue?vue&type=script&lang=js&"
import style0 from "./MemolanguageView.vue?vue&type=style&index=0&id=702a04a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702a04a5",
  null
  
)

export default component.exports